import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	SCHOLARSHIP_AWARD_DURATION_FEATURE_KEY,
	ScholarshipAwardDurationState,
	ScholarshipAwardDurationPartialState,
	scholarshipAwardDurationAdapter
} from './scholarshipawardduration.reducer';

// Lookup the 'ScholarshipAwardDuration' feature state managed by NgRx
export const getScholarshipAwardDurationState = createFeatureSelector<
	ScholarshipAwardDurationPartialState,
	ScholarshipAwardDurationState
>(SCHOLARSHIP_AWARD_DURATION_FEATURE_KEY);

const { selectAll, selectEntities } = scholarshipAwardDurationAdapter.getSelectors();

export const getScholarshipAwardDurationLoaded = createSelector(
	getScholarshipAwardDurationState,
	(state: ScholarshipAwardDurationState) => state.loaded
);

export const getScholarshipAwardDurationError = createSelector(
	getScholarshipAwardDurationState,
	(state: ScholarshipAwardDurationState) => state.error
);

export const loadingScholarshipAwardDuration = createSelector(
	getScholarshipAwardDurationState,
	(state: ScholarshipAwardDurationState) => state.loaded
);

export const getAllScholarshipAwardDuration = createSelector(
	getScholarshipAwardDurationState,
	(state: ScholarshipAwardDurationState) => selectAll(state)
);

export const getScholarshipAwardDurationEntities = createSelector(
	getScholarshipAwardDurationState,
	(state: ScholarshipAwardDurationState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getScholarshipAwardDurationState,
	(state: ScholarshipAwardDurationState) => state.selectedScholarshipAwardDurationId
);

export const getSelected = createSelector(
	getScholarshipAwardDurationEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
